import { gql } from '@apollo/client'

export const ACCOMMODATION_IMAGES_QUERY = gql`
  query AccommodationImages($propertyCode: String!) {
    accommodationImages(propertyCode: $propertyCode) {
      url
      size
      name
      id
    }
  }
`
